
import { MyProfile } from './MyProfile'

const ProfilePage = () => {
  return (
    <div>
        <MyProfile />
      
    </div>
  )
}

export default ProfilePage
